export default [
  { id: 'assurance', labelStringId: 'assurance', path: '/assurance', icon: 'fa-thin fa-truck-bolt' },
  { id: 'groups', labelStringId: 'groups', path: '/groups', icon: 'fa-thin fa-car-bus' },
  { id: 'devices', labelStringId: 'devices', path: '/devices', icon: 'fa-thin fa-laptop-mobile' },
  { id: 'insights', labelStringId: 'insights', path: '/insights', icon: 'fa-thin fa-chart-line' },
];
